import { styled } from '../../theme'

export const BackgroundContainer = styled.div`
  .ant-page-header {
    background-color: ${(props) => props.theme.colors.grayBackground};
    padding: 16px 0 4px 0;
  }
`
